export interface Company {
  id: number;
  name: string;
  email: string | null;
  phone: string | null;
  address?: string | null;
  currency: string;
  tax_number: string | null;
  allow_negative_inventory?: boolean;
  active: boolean;
}

export interface AuthUser {
  id: number;
  name: string;
  email: string;
  role: string;
  active: boolean;
  company?: Company;
  created_at: string;
}

export interface LoginResponse {
  token: string;
  user: AuthUser;
}

export interface MeResponse {
  data: AuthUser;
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export class ApiValidationError extends Error {
  errors: Record<string, string[]>;

  constructor(message: string, errors: Record<string, string[]>) {
    super(message);
    this.name = 'ApiValidationError';
    this.errors = errors;
  }
}
